export default {
  activateLandingPageTitle: 'Evenimente',
  activateProductCardTitle: 'Evenimente',
  activateProductPageTitle: 'Rezervă Evenimente',
  allProductsLandingPageTitle: 'Rezervă Experiențe Unice',
  apply: 'Aplică',
  buyTickets: 'Cumpără bilete',
  cancel: 'Anulează',
  clear: 'Șterge',
  clearFilters: 'Șterge filtrele',
  discoverExperiences: 'Descoperă experiențe',
  exclusive: 'Exclusiv',
  experience: 'experiență',
  experiencePhotoOfListing:
    'Fotografia experienței {{photoNumber}} din listarea {{listingTitle}}',
  experiences: 'experiențe',
  filterExperiences: 'Filtrează experiențele',
  fromListingCard: 'De la',
  hostedBy: 'Găzduit de',
  hostLandingPageTitle: 'Experiențe locale',
  hostProductCardTitle: 'Experiențe Locale',
  hostProductPageTitle: 'Rezervă Experiențe Locale',
  landingPageTitle: 'Rezervă Experiențe Unice',
  mainLandingPageTitle: 'Toate Experiențele',
  more: 'Mai mult',
  noExperiencesFound: 'Nu s-au găsit experiențe',
  noExperiencesFoundFor: 'Nu s-au găsit experiențe pentru',
  experiencesFoundCount: '{{count}} experiențe găsite',
  profileImageOfHost: 'Imaginea de profil a gazdei {{hostName}}',
  reserve: 'Rezervă',
  reserveLandingPageTitle: 'Activități și facilități',
  reserveProductCardTitle: 'Activități',
  reserveProductPageTitle: 'Rezervă Activități și Facilități',
  resultsPageTitle: 'Rezervă Experiențe și Activități',
};
